export default "__VITE_ASSET__CLMpppHg__"